export default {
  styles: 'Estilos',
  text: {
    title: 'Título',
    subtitle: 'Subtítulo',
    paragraph: 'Texto',
  },
  list: {
    listOrdered: 'Lista numerada',
    bulletList: 'Lista con viñetas',
  },
  typography: {
    bold: 'Negrita',
    italic: 'Cursiva',
    underline: 'Subrayado',
  },
  utils: {
    highlight: 'Color de resaltado',
    link: 'Insertar enlace',
  },
};
